export const EFFECTIVE_YEAR = 2026;
